var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcApplicationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50_94",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.65 0H0V18H25.65V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50_94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6376 0L2.14697 3.97452L9.31559 7.23303L24.7936 3.15976L17.6376 0ZM17.5492 1.06452L21.7468 2.9183L17.6786 3.98876L13.3463 2.14301L17.5492 1.06452ZM25.5574 4.00256L9.39879 8.25476L9.22739 8.29989L9.22496 8.30047L9.06476 8.22758L0.980055 4.63459L0.969737 4.62942C0.656559 4.4728 0.520466 4.51773 0.365811 4.63558C0.211213 4.75335 0.0565587 5.02137 0.0139418 5.36211C-0.0712359 6.04359 0.216708 6.90863 1.35503 7.28802L1.37813 7.29585L9.3132 10.8224L19.0273 8.2661V6.55794L23.289 5.52924V7.14456L25.6539 6.5223C25.4094 5.73516 25.355 4.8879 25.5574 4.00256ZM22.2797 6.81111L20.0367 7.35259V13.1387L21.2674 11.908L22.2797 12.6088V6.81111ZM25.5574 7.59136L23.289 8.18834V10.7333L25.6539 10.111C25.4094 9.32391 25.355 8.47665 25.5574 7.59136ZM0.62622 8.11782C0.525119 8.11984 0.448073 8.16169 0.365923 8.22424C0.211269 8.34205 0.0566149 8.61007 0.013998 8.95081C-0.0711797 9.63229 0.216765 10.4973 1.35508 10.8768L1.37818 10.8845L9.3132 14.4112L19.0273 11.8549V9.30982L9.22739 11.8887L1.00568 8.23482C0.914503 8.20355 0.82467 8.16844 0.736407 8.1297C0.700286 8.12137 0.663296 8.11737 0.62622 8.11782ZM1.00568 8.23482L1.00692 8.23527L0.991269 8.22825L1.00568 8.23482ZM25.5574 11.1801L23.289 11.7771V14.3221L25.6539 13.6998C25.4094 12.9127 25.355 12.0654 25.5574 11.1801ZM0.62622 11.7066C0.525119 11.7086 0.448073 11.7504 0.365923 11.813C0.211269 11.9308 0.0566149 12.1988 0.013998 12.5396C-0.0711797 13.2211 0.216765 14.0861 1.35508 14.4656L1.37818 14.4733L9.3132 18L19.0273 15.4437V12.8986L9.22739 15.4775L1.00568 11.8236C0.914503 11.7923 0.82467 11.7572 0.736407 11.7185C0.700286 11.7102 0.663296 11.7062 0.62622 11.7066ZM1.00568 11.8236L1.00692 11.824L0.991269 11.817L1.00568 11.8236ZM21.3854 13.2173L19.2061 15.3966L23.066 14.3808L21.3854 13.2173Z",
    fill: "#E4151B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApplicationRed);
export default __webpack_public_path__ + "static/media/ic-application-red.cbb8408dcfdbc1237aba5929726d185e.svg";
export { ForwardRef as ReactComponent };